module.exports = __webpack_public_path__ + "img/img-carbs.b5124d75.png";